<template>
  <div>
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <!-- <draggable
      class="ul-draggable"
      tag="ul"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
    >
      <transition-group
        type="transition"
        :class="drag ? 'flip-list' : null"
      > -->
        <!-- <GroupOverview
          v-for="firm in firms"
          :key="firm.id"
          class="ul-draggable-item"
          :firm="firm"
          :mySurveys="mySurveys"
        ></GroupOverview> -->
        <template v-if="firms && mySurveys">
          <template v-if="firms.length > 0">
            <GroupOverview
              v-for="firm in firms"
              :key="firm.id"
              :firm="firm"
              :mySurveys="mySurveys"
              @reloadFirmList="reloadFirm"
              @reloadSurveyList="reloadSurvey"
            ></GroupOverview>
          </template>
          <EmptyGroupOverview v-else></EmptyGroupOverview>
        </template>
      <!-- </transition-group>
    </draggable> -->
  </div>
</template>

<script>
import { getFirm } from '@/js/firm/getFirm'
import { getMySurvey } from '@/js/survey/getSurvey'
// import draggable from 'vuedraggable'
import GroupOverview from '@/components/audits/GroupOverview'
import EmptyGroupOverview from '@/components/audits/EmptyGroupOverview'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  // display: 'Transitions',
  // order: 7,
  components: {
    // draggable,
    GroupOverview: GroupOverview,
    EmptyGroupOverview: EmptyGroupOverview,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      // drag: false,
      firms: null,
      mySurveys: null,
      httpalert: false
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    const key = this.$store.state.auth.token
    // get user firm list
    getFirm(key)
      .then(response => {
        if (!response) this.$store.dispatch('auth/authLogout')
        this.firms = response
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
        this.$store.dispatch('auth/authLogout')
      })

    getMySurvey(key)
      .then(response => {
        if (!response) this.$store.dispatch('auth/authLogout')
        this.mySurveys = response
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
        this.$store.dispatch('auth/authLogout')
      })
  },


  methods: {
    reloadFirm () {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      getFirm(this.$store.state.auth.token)
        .then(response => {
          this.firms = response
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },
    reloadSurvey () {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      getMySurvey(this.$store.state.auth.token)
        .then(response => {
          if (!response) this.$store.dispatch('auth/authLogout')
          this.mySurveys = response
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }

  // computed: {
  //   dragOptions() {
  //     return {
  //       animation: 362,
  //       group: 'description',
  //       disabled: false
  //     }
  //   }
  // }
}
</script>
